import React, { Component } from 'react';
import CardWidget from "../card-widget/CardWidget";
import CardWidgetContent from "../card-widget/CardWidgetContent";

class UnavailableInitialization extends Component {

    getTAUserUnavilableContent = () => {
        return (
            <div>
                <CardWidgetContent contentText="student_section.unavailable" />
            </div>
        )
    };

    render() {
        return (
            <CardWidget getCardContent={this.getTAUserUnavilableContent} />
        )
    };
}

export default UnavailableInitialization;